import { React, useState, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from "react-redux";
import AutosuggestComponent from './AutosuggestComponent';

const QuotationBodyAutosuggest = ({
    style,
    input_style,
    label,
    type,
    placeholder,
    name,
    value,
    onChange,
    required,
    hidden,
    disabled,
    display,
    setFormData
}) => {
    const selectBoxList = useSelector((state) => state.admin.selectBoxList);
    const autoSuggestionList = useMemo(() => selectBoxList?.categories?.filter((item) => item.type === "QuotationBody") || [], [selectBoxList]);
    const [suggestions1, setSuggestions1] = useState([]);

    const escapeRegexCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const getSuggestions1 = (value) => {
        if (!value || typeof value !== "string") {
            return [];
        }

        setFormData((prev) => ({
            ...prev,
            subject: value,
        }));
        return autoSuggestionList.filter((user) => {
            const itemData = `${user?.label?.toUpperCase() || ""} 
                              ${user?.description?.toUpperCase() || ""}`.trim();

            const textData = escapeRegexCharacters(value.trim().toUpperCase());

            return itemData.includes(textData);
        });
    };

    const getSuggestionValue1 = (suggestion) => suggestion?.customObject?.vehicle_nick_name || "";

    const onChange1 = (event, { newValue }) => {
        setFormData((prev) => ({
            ...prev,
            subject: newValue,
        }));
    };

    const onSuggestionsFetchRequested1 = ({ value, reason }) => {
        if (!value || typeof value !== "string") return;
        if (reason === "input-changed") {
            let newData = getSuggestions1(value);
            setSuggestions1(newData);
        }
    };

    useEffect(() => {
            if (autoSuggestionList.length !== suggestions1.length) {
                setSuggestions1(autoSuggestionList);
            }
        }, [autoSuggestionList]);
    

    const onSuggestionsClearRequested1 = () => {
        setSuggestions1([]);
    };

    const onSuggestionSelected1 = (event, { suggestion }) => {
        event.preventDefault();

        if (!suggestion || !suggestion.label) {
            return;
        }

        setFormData((prev) => ({
            ...prev,
            subject: suggestion?.label,
            body: suggestion?.description,
        }));
    };

    const onBlur1 = (event, { highlightedSuggestion }) => {
        if (!highlightedSuggestion || !highlightedSuggestion.label) {
            return;
        }

        setFormData((prev) => ({
            ...prev,
            subject: highlightedSuggestion?.label,
            body: highlightedSuggestion?.description,
        }));
    };


    return (
        <AutosuggestComponent
            style={style}
            input_style={input_style}
            label={label}
            type={type}
            placeholder="Subjects..."
            required={required}
            name={name}
            value={value}
            hidden={hidden}
            disabled={disabled}
            display={display}
            suggestions={suggestions1}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested1}
            onSuggestionSelected={onSuggestionSelected1}
            onSuggestionsClearRequested={onSuggestionsClearRequested1}
            getSuggestionValue={getSuggestionValue1}
            onChange={onChange1}
            onBlur={onBlur1}
        />
    );
};

QuotationBodyAutosuggest.propTypes = {
    style: PropTypes.string,
    input_style: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    display: PropTypes.bool,
    setFormData: PropTypes.func,
}

export default QuotationBodyAutosuggest;
